// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    SiteModelsSiteRequestModel,
    TCApiGatewayControllersModelsRequestTypesSiteRequestModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgeSiteApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param siteId 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesSiteRequestModel 
     */
    public async netApiSite (siteId?: number, xProgramId?: string, tCApiGatewayControllersModelsRequestTypesSiteRequestModel?: TCApiGatewayControllersModelsRequestTypesSiteRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Site';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (siteId !== undefined) {
            _params_['siteId'] = Serializer.serialize(siteId, "number");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesSiteRequestModel, "TCApiGatewayControllersModelsRequestTypesSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param siteId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async netApiSite_1 (siteId?: number, xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Site';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (siteId !== undefined) {
            _params_['siteId'] = Serializer.serialize(siteId, "number");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'DELETE',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param siteModelsSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteCreate (siteModelsSiteRequestModel: SiteModelsSiteRequestModel, xProgramId?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/site/SiteControl/create';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteModelsSiteRequestModel' is not null or undefined
        if (siteModelsSiteRequestModel === null || siteModelsSiteRequestModel === undefined) {
            throw new Error('Required parameter siteModelsSiteRequestModel was null or undefined when calling siteCreate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteModelsSiteRequestModel, "SiteModelsSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     * @param tCApiGatewayControllersModelsRequestTypesSiteRequestModel 
     */
    public async siteCreate_2 (xProgramId?: string, tCApiGatewayControllersModelsRequestTypesSiteRequestModel?: TCApiGatewayControllersModelsRequestTypesSiteRequestModel): Promise<AxiosResponse> {
        const _url_ = '/netApi/Site/create';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(tCApiGatewayControllersModelsRequestTypesSiteRequestModel, "TCApiGatewayControllersModelsRequestTypesSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param siteId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteDelete (siteId: number, xProgramId?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/site/SiteControl/delete/{siteId}'
            .replace('{' + 'siteId' + '}', encodeURIComponent(String(siteId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteId' is not null or undefined
        if (siteId === null || siteId === undefined) {
            throw new Error('Required parameter siteId was null or undefined when calling siteDelete.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'DELETE',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
    /**
     * 
     * @param siteId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteRetrieve (siteId: number, xProgramId?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/site/SiteControl/retrieve/{siteId}'
            .replace('{' + 'siteId' + '}', encodeURIComponent(String(siteId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteId' is not null or undefined
        if (siteId === null || siteId === undefined) {
            throw new Error('Required parameter siteId was null or undefined when calling siteRetrieve.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
    /**
     * 
     * @param siteId 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteRetrieve_3 (siteId?: number, xProgramId?: string): Promise<AxiosResponse> {
        const _url_ = '/netApi/Site/retrieve';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        if (siteId !== undefined) {
            _params_['siteId'] = Serializer.serialize(siteId, "number");
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request(requestConfig);

        return response;
    }
    /**
     * 
     * @param siteId 
     * @param siteModelsSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteUpdate (siteId: number, siteModelsSiteRequestModel: SiteModelsSiteRequestModel, xProgramId?: string): Promise<AxiosResponse<any>> {
        const _url_ = '/edge/site/SiteControl/update/{siteId}'
            .replace('{' + 'siteId' + '}', encodeURIComponent(String(siteId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteId' is not null or undefined
        if (siteId === null || siteId === undefined) {
            throw new Error('Required parameter siteId was null or undefined when calling siteUpdate.');
        }

        // verify required parameter 'siteModelsSiteRequestModel' is not null or undefined
        if (siteModelsSiteRequestModel === null || siteModelsSiteRequestModel === undefined) {
            throw new Error('Required parameter siteModelsSiteRequestModel was null or undefined when calling siteUpdate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteModelsSiteRequestModel, "SiteModelsSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<any>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "any");
        }
        return response;
    }
}
